module.exports = __webpack_public_path__ + "img/swimmers.d75459c2.jpg";